import day from 'dayjs'

export const fieldParse = (value: string) => {
  if (!day(value).isValid()) return ''
  const dateTimeValue = day(value).format('YYYY-MM-DD HH:mm')

  return dateTimeValue
}